export const emailValidation = (value) => {
  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i;

  if (!regex.test(value.trim())) {
    return {
      message: 'Enter a valid email address.',
      status: 'error',
    }
  }
};

export const emailMask = [
  {
    regexp: /^.+$/,
    placeholder: 'example',
  },
  { fixed: '@' },
  {
    regexp: /^[\w]+$/,
    placeholder: 'domain',
  },
  { fixed: '.' },
  {
    regexp: /^[\w]+$/,
    placeholder: 'com',
  },
];

export const countryCodeMask = [
  {
    regexp: /^(\+?\d{1,7}|\d{1,8})$/
  }
];

export const phoneMask = [
  {
    regexp: /^[+{1}][\d\s]+$/,
    placeholder: '+XXX',
  }
];

export const phoneMaskWithoutCountryCode = [
  {
    regexp: /^[0-9 ]+$/,
    placeholder: 'XXXXXXXXXX',
  }
];
